var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Khởi tạo hóa đơn",
            visible: _vm.isOpenInitializeOrderKidsExcelDialog,
            width: "900px",
            "before-close": _vm.handleClose,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isOpenInitializeOrderKidsExcelDialog = $event
            },
          },
        },
        [
          _c(
            "el-row",
            { staticClass: "overwrite" },
            [
              _c("el-col", { attrs: { span: 9 } }, [
                _c(
                  "div",
                  [
                    _c(
                      "el-checkbox",
                      {
                        model: {
                          value: _vm.overwritePayment,
                          callback: function ($$v) {
                            _vm.overwritePayment = $$v
                          },
                          expression: "overwritePayment",
                        },
                      },
                      [_vm._v("Cho phép ghi đè khoản thu\n          ")]
                    ),
                  ],
                  1
                ),
              ]),
              _c("el-col", { attrs: { span: 7 } }, [
                _c(
                  "div",
                  [
                    _c(
                      "el-checkbox",
                      {
                        model: {
                          value: _vm.overwriteNote,
                          callback: function ($$v) {
                            _vm.overwriteNote = $$v
                          },
                          expression: "overwriteNote",
                        },
                      },
                      [_vm._v("Cho phép ghi đè ghi chú\n          ")]
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "overwrite", staticStyle: { "margin-top": "25px" } },
            [
              _c(
                "el-col",
                { attrs: { span: 9 } },
                [
                  _c(
                    "el-checkbox",
                    {
                      staticStyle: { color: "black" },
                      on: { change: _vm.changeCreateMoney },
                      model: {
                        value: _vm.checkCreateMoney,
                        callback: function ($$v) {
                          _vm.checkCreateMoney = $$v
                        },
                        expression: "checkCreateMoney",
                      },
                    },
                    [
                      _vm._v(
                        "Thêm mới tiền đã thu\n          (Lần đầu)\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-checkbox",
                    {
                      staticStyle: { color: "black" },
                      on: { change: _vm.changeUpdateMoney },
                      model: {
                        value: _vm.checkUpdateMoney,
                        callback: function ($$v) {
                          _vm.checkUpdateMoney = $$v
                        },
                        expression: "checkUpdateMoney",
                      },
                    },
                    [_vm._v("Cập nhật tiền đã\n          thu\n        ")]
                  ),
                  _vm.updateMoney === "UPDATE_MONEY"
                    ? _c(
                        "el-row",
                        { staticStyle: { "margin-top": "15px" } },
                        [
                          _c(
                            "el-col",
                            [
                              _c(
                                "el-radio-group",
                                {
                                  model: {
                                    value: _vm.statusTransactionEntry,
                                    callback: function ($$v) {
                                      _vm.statusTransactionEntry = $$v
                                    },
                                    expression: "statusTransactionEntry",
                                  },
                                },
                                [
                                  _c(
                                    "el-radio",
                                    {
                                      staticStyle: { color: "black" },
                                      attrs: { label: "MONEY_WALLET" },
                                    },
                                    [_vm._v("Không chuyển")]
                                  ),
                                  _c(
                                    "el-radio",
                                    {
                                      staticStyle: { color: "black" },
                                      attrs: { label: "MONEY_MONTH" },
                                    },
                                    [_vm._v("Sang tháng sau")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                {
                  staticStyle: { "margin-top": "20px" },
                  attrs: { offset: 18, span: 8 },
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", loading: _vm.loadingImport },
                      on: { click: _vm.submitImport },
                    },
                    [
                      _vm._v("Khởi tạo "),
                      _c("i", { staticClass: "el-icon-upload el-icon-right" }),
                    ]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "danger" },
                      on: { click: _vm.handleClose },
                    },
                    [
                      _c("i", { staticClass: "el-icon-circle-close" }),
                      _vm._v(" Đóng\n        "),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }